import type { AuthUser, GoogleJwtPayload } from '../types/auth'

export const JwtUtils = {
  /**
   * Decodes a JWT token and returns its payload
   * @throws Error if token format is invalid
   */
  decodeToken(token: string): GoogleJwtPayload {
    const parts = token.split('.')
    if (parts.length !== 3) {
      throw new Error('Invalid token format')
    }

    const base64Url = parts[1]
    if (!base64Url) {
      throw new Error('Invalid token payload')
    }

    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    )

    const payload = JSON.parse(jsonPayload) as GoogleJwtPayload
    // console.log('[JWT Debug] Decoded payload:', {
    //   sub: payload.sub,
    //   email: payload.email,
    //   hd: payload.hd,
    //   fullPayload: process.env.NODE_ENV === 'development' ? payload : undefined
    // })

    return payload
  },

  /**
   * Converts a GoogleJwtPayload to AuthUser
   */
  payloadToUser(payload: GoogleJwtPayload): AuthUser {
    // console.log('[JWT Debug] Converting payload to user:', {
    //   sub: payload.sub,
    //   email: payload.email,
    //   hostedDomain: payload.hd
    // })

    const user = {
      id: payload.sub,
      email: payload.email,
      name: payload.name,
      picture: payload.picture,
      givenName: payload.given_name,
      familyName: payload.family_name,
      emailVerified: payload.email_verified,
      hostedDomain: payload.hd,
      roles: ['USER'] as UserRole[]
    }

    // console.log('[JWT Debug] Created user object:', {
    //   id: user.id,
    //   email: user.email,
    //   roles: user.roles
    // })

    return user
  },

  /**
   * Checks if a token is expired or will expire within the given threshold
   * @param payload The decoded token payload
   * @param thresholdMs Time in milliseconds before expiry to consider token as expired
   */
  isTokenExpired(decodedToken: GoogleJwtPayload): boolean {
    return decodedToken.exp * 1000 < Date.now()
  },

  isTokenExpiring(decodedToken: GoogleJwtPayload, thresholdMs: number = 300000): boolean {
    const expiryTime = decodedToken.exp * 1000
    return expiryTime - Date.now() < thresholdMs
  }
}
